import React from 'react';
import {
  Card,
  CardHeader,
  Input,
  Container,
  Table,
  Row,
} from 'reactstrap';
import { useState } from 'react';
import { failureToast, successToast } from '../../common/utils/methods/toasterFunctions/function';
import { TDROW, MasterHeader } from '../../common/commonComponents/masterRow/masterRow';
import { masterServiceBaseUrl, putpost, putpost2 } from 'services/http';
import moment from 'moment';
import CustomButton from "components/CustomButton";

var _ = require('lodash');

const AdmissionAgentTypeTable = (props) => {
  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [tableDataKey, settableDataKey] = useState('tableDataKey');
  const addNewClass = () => {
    props.setclassArray([
      {
        editMode: true,
        __status: '__new',
        admissionAgentTypeKey: null,
        status: 'ACTIVE',
        admissionAgentTypeDesc: null,
        admissionAgentTypeDispValue: null,
        effectiveDate: null,
      },
      ...props.classArray,
    ]);
  };
  const saveAll = (cb) => {
    var _tempArray = props.classArray;
    var isValid = true;
    _tempArray.forEach((el, index) => {
      if (el['editMode']) {
        if (
          el['admissionAgentTypeKey'] == null ||
          !el['admissionAgentTypeKey'].trim()
        ) {
          isValid = false;
          failureToast('Please enter the value of Admission Agent Type Key');
          return;
        } else if (
          el['admissionAgentTypeDesc'] == null ||
          !el['admissionAgentTypeDesc'].trim()
        ) {
          isValid = false;
          failureToast('Please enter the value of Description');
          return;
        } else if (
          el['admissionAgentTypeDispValue'] == null ||
          !el['admissionAgentTypeDispValue'].trim()
        ) {
          isValid = false;
          failureToast('Please enter the value of Display Value');
          return;
        }
        if (!isValid) {
          return;
        }
        if (_tempArray[index]['__status'] == '__new') {
          putpost(
            masterServiceBaseUrl + '/admissionAgentType/createAdmissionAgentType',
            (data) => {
              successToast(data['message']);
              setisSaveVisible(false);
              props.getAllRecords();
            },
            (data) => {
              failureToast(data['message']);
            },
            _tempArray[index],
            'post'
          );
        } else {
          putpost(
            masterServiceBaseUrl +
              '/admissionAgentType/updateAdmissionAgentType/' +
              _tempArray[index].id,
            (data) => {
              successToast(data['message']);
              setisSaveVisible(false);
              delete _tempArray[index]['editMode'];
              props.setclassArray(_tempArray);
              settableDataKey(new Date().getMilliseconds());
              // props.fetchClasses(masterServiceBaseUrl + '/class/getAllClass')
            },
            (data) => {
              failureToast(data['message']);
            },
            _tempArray[index],
            'put'
          );
        }
      } else {
      }
    });
  };
  const newRow = () => {
    if (isSaveVisible) {
      failureToast('Please Delete or Save current changes');
    } else {
      let cb = () => {
        addNewClass();
        setisSaveVisible(true);
        // settableDataKey(new Date().getMilliseconds())
      };
      var _tempArray = props.classArray;
      _tempArray = _.sortBy(_tempArray, [
        function (o) {
          return o.value;
        },
      ]);
      props.setclassArray(_tempArray);
      setisSaveVisible(false);
      cb();
    }
  };
  const editRow = (index) => {
    if (isSaveVisible) {
      failureToast('Please Delete or Save current changes');
    } else {
      let cb = () => {
        var _tempArray = props.classArray;
        _tempArray[index]['editMode'] = true;
        props.setclassArray(_tempArray);
        setisSaveVisible(true);
      };
      var _tempArray = props.classArray;
      _tempArray = _.sortBy(_tempArray, [
        function (o) {
          return o.value;
        },
      ]);
      cb();
    }
  };
  const deleteRow = (index) => {
    if (props.classArray[index]['__status'] == '__new') {
      let n = props.classArray;
      n.splice(index, 1);
      props.setclassArray(n);
      setisSaveVisible(false);
      settableDataKey(new Date().getMilliseconds());
    } else {
      if (
        window.confirm(
          'Are you sure you want to delete this Admission Agent Type?'
        )
      ) {
        putpost2(
          masterServiceBaseUrl +
            '/admissionAgentType/deleteAdmissionAgentType/' +
            props.classArray[index].id,
          (data) => {
            successToast(data['message']);
            if (props.classArray.length == 1) {
              props.getAllRecords(true);
            } else {
              var _tempArray = props.classArray;
              if (_tempArray[index]['editMode']) {
                setisSaveVisible(false);
              }
              _tempArray.splice(index, 1);
              props.setclassArray(_tempArray);
            }
            settableDataKey(new Date().getMilliseconds());
          },
          (data) => {
            failureToast(data['message']);
          },
          'PUT'
        );
      }
    }
  };
  const updateKey = (index, value, key) => {
    var _tempArray = props.classArray;
    _tempArray[index][key] = value;
    props.setclassArray(_tempArray);
  };

  const onCancel = (index) => {
    let n = props.classArray;
    if (n[index]['__status'] == '__new') {
      n.splice(index, 1);
    } else {
      // n[index]['editMode']=false
      props.getAllRecords();
    }
    props.setclassArray(n);
    setisSaveVisible(false);
  }
  return (
    <>
      <Container className="mt-3" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <h3 className="mb-0 floatLeft">
                  Master - Admission Agent Type
                </h3>
                <CustomButton
                  data-testid="addNewRow"
                  className={
                    'floatRight mx-1' + (isSaveVisible ? ' btn-dark' : null)
                  }
                  content={"New Admission Agent Type"}
                  icon={true}
                  permissionType={'C'}
                  onClick={() => {
                    newRow();
                  }}
                  permissionSet={props.userPermissions}
                />
                {/* {isSaveVisible?<Button color="info" size="sm" type="button" className="floatRight mx-1" onClick={() => {saveAll()}}>Save</Button>:null} */}
              </CardHeader>
              <div id="questionTable" className="table-responsive">
                <Table className="align-items-center table-flush tableLayout">
                  <MasterHeader type={'Admission Agent Type'} permissionSet={props.userPermissions} />
                  <tbody className="list" key={tableDataKey}>
                    {props.classArray
                      ? props.classArray.map((el, index) =>
                          !el['editMode'] ? (
                            <TDROW
                              type={'admissionAgentType'}
                              index={index}
                              el={el}
                              editRow={editRow}
                              deleteRow={deleteRow}
                              permissionSet={props.userPermissions}
                            />
                          ) : (
                            <tr key={index + '-class'}>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  data-testid="admissionAgentTypeKey"
                                  maxLength={50}
                                  defaultValue={el['admissionAgentTypeKey']}
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value,
                                      'admissionAgentTypeKey'
                                    );
                                  }}
                                  placeholder="Example:1"
                                  className="tdInput"
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  data-testid="effectiveDate"
                                  disabled={true}
                                  defaultValue={
                                    el['__status'] == '__new'
                                      ? null
                                      : moment(el['effectiveDate']).format(
                                          'DD-MM-YYYY'
                                        )
                                  }
                                  placeholder="Example:01-01-2020"
                                  className="tdInput"
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  data-testid="admissionAgentTypeDesc"
                                  maxLength={50}
                                  defaultValue={el['admissionAgentTypeDesc']}
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value,
                                      'admissionAgentTypeDesc'
                                    );
                                  }}
                                  placeholder="Description"
                                  className="tdInput"
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <Input
                                  data-testid="admissionAgentTypeDispValue"
                                  maxLength={50}
                                  defaultValue={
                                    el['admissionAgentTypeDispValue']
                                  }
                                  onChange={(e) => {
                                    updateKey(
                                      index,
                                      e.target.value,
                                      'admissionAgentTypeDispValue'
                                    );
                                  }}
                                  placeholder="Display Value"
                                  className="tdInput"
                                />
                              </td>
                              <td className="text-center p-2 mx-1">
                                <label className="custom-toggle mx-auto ml-2">
                                  <input
                                    data-testid="activeInactiveInput"
                                    checked={
                                      el.status == 'ACTIVE' ? true : false
                                    }
                                    type="checkbox"
                                    id={el.id}
                                    onChange={(e) => {
                                      settableDataKey(
                                        new Date().getMilliseconds()
                                      );
                                      let n = 'ACTIVE';
                                      if (!e.target.checked) {
                                        n = 'INACTIVE';
                                      }
                                      updateKey(index, n, 'status');
                                    }}
                                  />
                                  <span
                                    data-testid="activeInactiveLabel"
                                    style={{ width: '72px' }}
                                    className="custom-toggle-slider rounded-circle activeToggle"
                                    data-label-off="Inactive"
                                    data-label-on="Active"
                                  />
                                </label>
                              </td>
                              <td className="text-center">
                                {/* <Button color="info" size="sm" type="button" onClick={() => {
                          deleteRow(index)
                        }}>  <i className="fas fa-trash" /></Button> */}
                                {isSaveVisible ? (
                                  <>
                                    {' '}
                                    <CustomButton
                                      data-testid="saveBtn"
                                      className={'mx-1'}
                                      content={"Save"}
                                      permissionType={'C'}
                                      forTable={true}
                                      onClick={() => {
                                        saveAll();
                                      }}
                                      permissionSet={props.userPermissions}
                                    />
                                    <CustomButton
                                      data-testid="closeBtn"
                                      icon={true}
                                      permissionType={'cancel'}
                                      forTable={true}
                                      onClick={() => onCancel(index)}
                                      permissionSet={props.userPermissions}
                                    />
                                    {' '}
                                  </>
                                ) : (
                                  <CustomButton
                                    permissionType={'D'}
                                    forTable={true}
                                    icon={true}
                                    onClick={() => {
                                      deleteRow(index);
                                    }}
                                    permissionSet={props.userPermissions}
                                  />
                                )}
                              </td>
                            </tr>
                          )
                        )
                      : null}
                  </tbody>
                </Table>
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
export default AdmissionAgentTypeTable;
